module.exports = __webpack_public_path__ + "static/media/Appachatti.7011c5e2.jpeg";